import { Context, createWrapper } from 'next-redux-wrapper';
import { applyMiddleware, combineReducers, createStore, Store } from 'redux';
import thunk from 'redux-thunk';
import bidBarrelReducer from './bidbarrel/bidBarrelReducer';
import hydrationReducer from './hydrationReducer';
import { IGlobalStore } from './reduxTypes';
import userReducer from './user/userReducer';

const reducer = combineReducers({
  hydration: hydrationReducer,
  bidbarrel: bidBarrelReducer,
  user: userReducer
});

const makeStore = (context: Context) =>
  createStore(reducer, applyMiddleware(thunk));

export const nextReduxWrapper = createWrapper<Store<IGlobalStore>>(makeStore, {
  debug: false
});
